import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {

      let canvasHeader = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.scroll.viewbox.y - this.header.height})`)
      .attr('font-family', 'roboto')
      

      this.gmx_Line(canvasHeader, 0, this.header.width+5, 0, 0, '#757575', 1, 1)
      this.gmx_Line(canvasHeader, 0, this.header.width+5, this.header.height, this.header.height, '#757575', 1, 1)

      this.header.cols.forEach(col=> {
        
        canvasHeader
        .append('text')
        .attr('x', ()=> {
          let x = this.columns[col.idx].mx
          if(col.span > 1) x = this.columns[col.idx].sx + (this.columns[col.idx+(col.span-1)].ex - this.columns[col.idx].sx) / 2
          return x
        })
        .attr('y', ()=> {
          let y = (this.header.height/2) + 4
          if(col.ty == '1') y = this.header.depth[0]
          if(col.ty == '2') y = this.header.depth[1]
          return y
        })
        .attr('font-size', col.tSize).attr('fill', col.tColor).attr('text-anchor', 'middle')
        .text(col.name)

        if(col.span > 1) {
          canvasHeader
          .append('line')
          .attr('x1', this.columns[col.idx].sx).attr('y1', this.header.lineY)
          .attr('x2', this.columns[col.idx+(col.span-1)].ex).attr('y2', this.header.lineY)
          .attr('stroke', '#aaa').attr('stroke-width', 0.5)
        }
      })
      

    },

  }
}